class User {
    constructor() {
        this.data = {};
      }

    setData (data) {
        this.data = data;
    }

    get userData () {
        return this.data;
    }
}

export default new User;